/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailureCountVm
 */
export interface FailureCountVm {
    /**
     * 
     * @type {number}
     * @memberof FailureCountVm
     */
    expiredDeadlineFailureCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureCountVm
     */
    nearDeadlineFailureCount?: number;
}

export function FailureCountVmFromJSON(json: any): FailureCountVm {
    return FailureCountVmFromJSONTyped(json, false);
}

export function FailureCountVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureCountVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expiredDeadlineFailureCount': !exists(json, 'expiredDeadlineFailureCount') ? undefined : json['expiredDeadlineFailureCount'],
        'nearDeadlineFailureCount': !exists(json, 'nearDeadlineFailureCount') ? undefined : json['nearDeadlineFailureCount'],
    };
}

export function FailureCountVmToJSON(value?: FailureCountVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expiredDeadlineFailureCount': value.expiredDeadlineFailureCount,
        'nearDeadlineFailureCount': value.nearDeadlineFailureCount,
    };
}


